<script lang="ts">
  import { GridView, PageView, Button } from '$shared/components';
  import authService from '$shared/services/authService';
  import MultipleRecordResult from './MultipleRecordResult.svelte';
  import type { EntityViewType } from '$shared/components/types';
  import { Module } from '$shared/constants/Module';
import { ButtonSize } from '$shared/constants/ButtonSize';

  interface Props {
    loading?: boolean;
    verifiedOn?: string;
    disabled?: boolean;
    optionsList: EntityViewType[];
    onreject?: () => void;
    onaccept?: (detail: any) => void;
    onevent?: (detail: any) => void;
  }

  let {
    loading = false,
    verifiedOn = '',
    disabled = false,
    optionsList,
    onreject,
    onaccept,
    onevent
  }: Props = $props();

  let rejected = $state(false);

  const onClickRejected = (): void => {
    rejected = true;
    onreject?.();
  };

  const onEvent = (payload: any): void => {
    const { type } = payload;
    if (type === 'accept') {
      onaccept?.(payload);
      return;
    }
    onevent?.(payload);
  };
</script>

<GridView>
  <PageView>
    <div class="multiple-records-review">
      <div class="alert">
        <div class="text">Multiple records found. Please select a correct match.</div>
        <div class="date">
          {verifiedOn || ''}
        </div>
      </div>
      <div class="no-match-btn">
        <Button
          name="noResultMatch"
          loading={rejected && loading}
          disabled={(rejected && loading) ||
            disabled ||
            !authService.getUserRole().hasWritePermission(Module.Providers)}
          icon="icon-x"
          size={ButtonSize.Large}
          onclick={onClickRejected}>None of these results match</Button
        >
      </div>

      {#each optionsList || [] as options, index}
        <MultipleRecordResult {options} onevent={onEvent} />
      {/each}
    </div>
  </PageView>
</GridView>

<style>
  .alert {
    background-color: #ffffff;
    border: 1px solid #0d54f5;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 32px;
  }
  .alert .text {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: var(--blue);
  }
  .alert .date {
    font-weight: normal;
    font-size: 12px;
    line-height: 23px;
    color: var(--grey-medium);
    margin-left: 16px;
  }

  .multiple-records-review {
    position: relative;
  }
</style>
